const icon = state => state.icon;
const quotes = state => state.quotes;
const quote = state => state.quote;
const getListOfActiveQuoteStatuses = state =>
  state.quoteStatuses.filter(q => q.id < 5);
const getListOfRejectedQuoteStatuses = state =>
  state.quoteStatuses.filter(q => q.id > 5);
const getListOfQuoteTypes = state => state.quoteTypes;
const getListOfQuotePriorities = state =>
  state.quotePriorities.filter(q => q.id > 0);
const getQuoteStatus = state => quoteStatus => {
  return state.quoteStatuses.find(li => li.id === quoteStatus);
};
const getQuoteType = state => quoteType => {
  return state.quoteTypes.find(li => li.id === quoteType);
};
const getQuotePriority = state => quotePriority => {
  return state.quotePriorities.find(li => li.id === quotePriority);
};
const isEditable = state => [1, 2, 3, 4].includes(state.quote.quoteStatus);

const getPreviousQuotes = state => state.quote.previousQuotes;

export default {
  icon,
  getQuoteStatus,
  getListOfActiveQuoteStatuses,
  getListOfRejectedQuoteStatuses,
  getListOfQuoteTypes,
  getListOfQuotePriorities,
  getQuoteType,
  quotes,
  quote,
  getQuotePriority,
  isEditable,
  getPreviousQuotes
};
